import { useNavigate } from 'react-router-dom';

import { BottomSheet } from '@/components/ui/bottom-sheet';
import { Button } from '@/components/ui/button';
import { Text } from '@/components/ui/text';
import { withNextParam } from '@/utils/helpers/next-path';

/**
 * "Login necessário" — aparece quando um convidado tenta uma ação que exige
 * conta (plano de autenticação v2, J1).
 *
 * Promovida de `modules/auth` para cá quando o primeiro consumidor real
 * apareceu na camada `components/` (a `BottomNav`, que não pode importar de
 * `modules/`). Ela continua genérica: só navega para rotas públicas de auth.
 *
 * O destino de volta viaja em `?next=`: sem ele, entrar na conta devolveria a
 * pessoa à Home e a ação que ela tentou fazer estaria perdida — que é o momento
 * exato em que se desiste. Login e cadastro já resolvem o parâmetro.
 */
export function LoginRequiredSheet({
  open,
  onOpenChange,
  next,
  description = 'Entre na sua conta para continuar.',
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Caminho interno para onde voltar depois de logar/cadastrar. */
  next?: string;
  description?: string;
}) {
  const navigate = useNavigate();

  return (
    <BottomSheet
      open={open}
      onOpenChange={onOpenChange}
      title="Login necessário"
      description={description}
      footer={
        <div className="flex flex-col gap-2">
          <Button fullWidth onClick={() => navigate(withNextParam('/login', next))}>
            Entrar na sua conta
          </Button>
          <Button
            variant="secondary"
            fullWidth
            onClick={() => navigate(withNextParam('/register', next))}
          >
            Criar sua conta
          </Button>
          <Button variant="ghost" fullWidth onClick={() => onOpenChange(false)}>
            Voltar
          </Button>
        </div>
      }
    >
      <Text tone="muted">
        Esta ação precisa de uma conta para que possamos avisar você sobre o andamento e para que as
        organizações saibam com quem estão falando.
      </Text>
    </BottomSheet>
  );
}
